import { IconBookmark, IconBuildings, IconCoil, IconEnergyCircle, IconRuler, IconShare, IconSignal, IconTools } from '@assets/images/icon';
import { bell1 } from '@assets/images/main/iot/product';
import { airQuality1, coMeasure1, sensorThumb } from '@assets/images/main/sensor';

export default {
  a: [
    { text: 'Main Use', icon: IconCoil },
    { text: 'Measurement Items', icon: IconRuler },
    { text: 'Communication Band', icon: IconSignal },
    { text: 'Installation Environment', icon: IconEnergyCircle },
    { text: 'Power Type', icon: IconTools },
    { text: 'Key Features', icon: IconBuildings },
    { text: 'ORBRO Integration', icon: IconBookmark },
    { text: 'External Integration', icon: IconShare },
  ],

  b: [
    { text: 'Industrial equipment status detection' },
    { text: 'Temperature, humidity, leakage, pressure, vibration, contact, etc.' },
    { text: 'LoRa, RS-485' },
    { text: 'Construction sites, plants, logistics warehouses, etc.' },
    { text: 'Battery / DC power' },
    { text: 'Supports various sensor inputs, up to 6km LoRa wireless communication' },
    { text: 'Supported' },
    { text: 'API available' },
  ],

  c: [
    { text: 'CO₂ leakage detection and alert' },
    { text: 'Carbon monoxide, temperature' },
    { text: 'Wi-Fi, RS-485' },
    { text: 'Confined spaces, sewage treatment plants, waste facilities, etc.' },
    { text: 'Battery / DC power' },
    { text: 'Specialized CO₂ sensors for hazardous environments, suitable for sensitive and risky zones' },
    { text: 'Supported' },
    { text: 'API available' },
  ],

  d: [
    { text: 'Indoor air quality monitoring' },
    { text: 'Fine dust, CO₂, TVOC, temperature and humidity' },
    { text: 'Wi-Fi, RS-485' },
    { text: 'Indoor environments such as hospitals, offices, public facilities' },
    { text: 'DC 24V' },
    { text: 'High-precision air quality analysis, certified by Ministry of Environment' },
    { text: 'Supported' },
    { text: 'API available' },
  ],

  e: [
    { text: 'Emergency alert notification' },
    { text: 'Emergency button status' },
    { text: 'Bluetooth 5, Wi-Fi' },
    { text: 'Hospitals, warehouses, offices, on-site hallways' },
    { text: 'AAA battery' },
    { text: 'Text alert transmission, Wi-Fi connectivity, low power consumption' },
    { text: 'Supported' },
    { text: 'API available' },
  ],

  spec: [
    {},

    {
      image: sensorThumb,
      link: '/en/iot/LoRASensor',
      title: 'LoRa Sensor',
      desc: 'New',
    },
    {
      image: coMeasure1,
      link: '/en/iot/co2',
      title: 'CO₂ Detector',
      desc: 'New',
    },
    {
      image: airQuality1,
      link: '/en/iot/air',
      title: 'Air Quality Monitor',
      desc: 'New',
    },
    {
      image: bell1,
      link: '/en/iot/bell',
      title: 'Emergency Bell',
      desc: '',
    },
  ],
};
